module.exports = __webpack_public_path__ + "img/creative-bg.3f45b450.jpg";